import React from 'react';
import { PensionFinderTemplate } from '../pension-finder/template';
import { MABPropertyPortfolioTemplate } from '../mab-property-portfolio/template';
import { MABImportPortfolioTemplate } from '../mab-import-portfolio/template';
import { IframeTemplate } from '../iframe/template';

const templates = {
  'pension-finder': PensionFinderTemplate,
  'mab-property-portfolio': MABPropertyPortfolioTemplate,
  'mab-import-portfolio': MABImportPortfolioTemplate,
  iframe: IframeTemplate
};

export const CustomPageTemplates = React.memo(({ name, children, ...props }) => {
  if (name in templates) {
    const Template = templates[name];

    return <Template {...props} />;
  }

  return children;
});
